(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    

const handleIntersection = (entries, observer) => {
  if (!entries[0].isIntersecting) return;
  observer.unobserve(productRecommendationsSection);

  const url = productRecommendationsSection.dataset.url;
  fetch(url)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.product-recommendations');
      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;

        // Initialize Slick after recommendations are added to the DOM
        const carousel = document.querySelector('.prod-carousel');
        if (carousel && !$(carousel).hasClass('slick-initialized')) {
          $(carousel).slick({
            slidesToShow: 2,
            arrows: false,
            autoplay:true,
            
            // Add any other Slick settings you want
            responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
                slidesToShow: 2,
                autoplay:true,
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: false,
                slidesToShow: 1,
                autoplay:true,
              }
            }
          ],
          });
        }
      }
    })
    .catch((e) => {
      console.error(e);
    });
};

const productRecommendationsSection = document.querySelector('.product-recommendations');
const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });
observer.observe(productRecommendationsSection);


  } catch(e) { console.error(e); }
})();
})();
